import React, { ComponentProps, useMemo } from "react";
import { useNavigate, useParams } from "react-router";
import { useChatHistory } from "../../../adapters/cla/state/hooks/stateHooks.ts";
import { ResearchId } from "../../../adapters/insights-agent/state/AppState.ts";
import { useTermsAndConditionsState } from "../../../adapters/insights-agent/state/hooks/stateHooks.ts";
import { useFeatureFlagValue } from "../../../config/FeatureFlagManager/hooks.ts";
import { HistorySidebar as HistorySidebarLegacy } from "../../../feature-components/HistorySidebar/HistorySidebar.tsx";
import { HistorySidebarRedesign } from "../../../feature-components/HistorySidebar/HistorySidebarRedesign.tsx";
import { CustomContextMenu } from "./CustomContextMenu.tsx";
import { NewChatIcon } from "../../../ui-library/_icons/NewChatIcon.tsx";

export const ConnectedHistorySidebar: React.FC = () => {
  const historyState = useChatHistory();
  const historyItems: ComponentProps<typeof HistorySidebarLegacy>["items"] =
    useMemo(
      () =>
        historyState.map((chat) => ({
          value: chat.id as ResearchId,
          label: chat.name || "Untitled chat",
        })),
      [historyState],
    );
  const termsState = useTermsAndConditionsState();
  const navigate = useNavigate();
  const { id } = useParams();
  const enableRedesign = useFeatureFlagValue("enableHistorySidebarRedesign");
  const HistorySidebar = enableRedesign
    ? HistorySidebarRedesign
    : HistorySidebarLegacy;

  return (
    <HistorySidebar
      items={historyItems}
      onNewChat={() => {
        navigate("/chats/new");
      }}
      onSelectionChange={(id) => {
        navigate(`/chats/${id}`);
      }}
      activeItem={id as ResearchId}
      enableTermsAndConditions={termsState.status !== "acceptance_not_required"}
      newChatLabel={
        <>
          <NewChatIcon
            style={{
              /**
                     .Icon {
              margin-right: 8px;
              width: 16px;
              height: 16px;
              vertical-align: middle;
              line-height: 0;
              margin-top: -4px;
              margin-left: 5px;
            }
         */
              marginRight: 8,
              marginTop: -4,
              marginLeft: 5,
              width: 16,
              height: 16,
              verticalAlign: "middle",
              lineHeight: 0,
            }}
          />{" "}
          New Chat
        </>
      }
      ContextMenuComponent={CustomContextMenu}
    />
  );
};
